import { Routes, Route, useNavigate } from "react-router-dom";
import styled from "styled-components";
import Footer from "../components/Footer";
import HeaderAppBar from "../components/HeaderAppBar";
import SideBar from "../components/SideBar";
import FactoryList from "../containers/factory/FactoryList";
import MyProject from "../containers/project/MyProject";
import ProjectList from "../containers/project/ProjectList";
import EditMyProject from "../containers/project/EditMyProject";
import ManageProject from "../containers/project/ManageProject";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../features/store";
import { Box, InputLabel, makeStyles, Paper, Theme, Typography, createStyles, TextField, Button } from "@material-ui/core";
import BorderColorIcon from "@material-ui/icons/BorderColor";
import AddToPhotosIcon from "@material-ui/icons/AddToPhotos";
import BackupIcon from "@material-ui/icons/Backup";
import { useEffect, useState } from "react";
import { KISAUser } from "../models/KISAUser";
import { updateUser } from "../features/sliceReducer/userReducer";
import { Controller, SubmitHandler, useForm } from "react-hook-form";


const LayoutContainer = styled.main`
  position: relative;
  width: 100%;
  min-width: 1600px;
  background-color: #f4f5f9;
`;

const DashboardMain = styled.div`
  width: 100%;
`;

const DummyContainer = styled.div`
  width: 100%;
  height: 80px;
`;



const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    formContainer: {
      display: "flex",
      padding: "32px",
      justifyContent: "spaceBetween",
    },
    formGrid: {
      margin: "0 20px",
      border: "1px solid #dbdce0",
      " & h6": {
        padding: "16px",
        backgroundColor: "#dbdce0",
        marginBottom: "20px",
      },
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    labelAlign: {
      display: "flex",
      justifyContent: "start",
      alignItems: "center",
      flexBasis: "50%",
      padding: "8px 0 8px 12px",

      "& > label": {
        width: "180px",
        textAlign: "right",
        marginRight: "26px",
      },
    },
    inputSize: {
      width: "300px",
    },
    memberList: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      margin: " 20px 50px",
      "& div": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "20px 50px 20px 0",
        borderBottom: "1px solid #dbdce0",
        color: theme.palette.primary.dark,
        "& p": {
          padding: "0 20px 0 40px",
          fontSize: "16px",
        },
      },
    },
    detail: {
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      width: "100%",
      "& table": {
        width: "90%",
      },

      "& tr, th, td": {
        border: "1px solid grey",
        padding: "12px",
      },
    },
    detailTable: {
      flexGrow: 1,
    },
  })
);

const MyPage = () => {
  const classes = useStyle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, userToken } = useSelector((state: RootState) => state.auth);
  const [item, setCurrentUser] = useState({} as KISAUser);
  const { handleSubmit, reset, control } = useForm<KISAUser>();

  useEffect(() => {
    reset({ ...user });
  }, []);

  const onSubmit: SubmitHandler<KISAUser> = (data) => {
    console.log(data);
    dispatch(updateUser({ userToken, item: data, successHandler: () => { navigate("/inspect/"); } }))
  }

  return (
    <LayoutContainer>
      <SideBar />
      <DashboardMain>
        <HeaderAppBar />
        <DummyContainer />
        <Paper className={classes.formContainer}>
          {user ?
            <Box width="42%" p={2} className={classes.formGrid}>
              <Typography variant="subtitle1">
                <BorderColorIcon
                  style={{ marginRight: "8px", verticalAlign: "middle" }}
                />
                My Profile
              </Typography>
              <Box className={classes.labelAlign}>
                <InputLabel>사용자명</InputLabel>
                <Typography>{user.name}</Typography>
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>사용자 ID</InputLabel>
                <Typography>{user.loginID}</Typography>
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>비밀번호</InputLabel>
                <Controller
                  name="loginPW"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="loginPW"
                      id="loginPW"
                      type="password"
                      defaultValue={user.loginPW}
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>부서명</InputLabel>
                <Controller
                  name="department"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="department"
                      id="department"
                      defaultValue={user.department}
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>이메일</InputLabel>
                <Controller
                  name="email"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="email"
                      id="email"
                      defaultValue={user.email}
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>기준연도</InputLabel>
                <Controller
                  name="referenceYear"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="referenceYear"
                      id="referenceYear"
                      type="number"
                      defaultValue={user.referenceYear}
                    />
                  )}
                />
              </Box>
              <Box className={classes.labelAlign}>
                <InputLabel>자격증</InputLabel>
                <Controller
                  name="certification"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      {...field}
                      name="certification"
                      id="certification"
                      defaultValue={user.certification}
                    />
                  )}
                />
              </Box>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit(onSubmit)}
                startIcon={<AddToPhotosIcon />}
              > 저장</Button>
            </Box>
            :
            <Box></Box>
          }
        </Paper>
      </DashboardMain>
    </LayoutContainer >
  );
};

export default MyPage;